import { render, staticRenderFns } from "./person-identifier.html?vue&type=template&id=181785a9&scoped=true&"
import script from "./person-identifier.js?vue&type=script&lang=js&"
export * from "./person-identifier.js?vue&type=script&lang=js&"
import style0 from "./person-identifier.scss?vue&type=style&index=0&id=181785a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181785a9",
  null
  
)

export default component.exports